import React from 'react';
import styled from 'styled-components';
export const BrandButton = ({
	source,
	aspectRatio,
	active,
	onClick,
	bonusCount,
}: {
	source: string | undefined;
	aspectRatio: number;
	active: boolean;
	onClick: () => void;
	bonusCount: number;
}) => {
	return (
		<ButtonWrapper onClick={onClick} active={active}>
			<Image active={active} aspectRatio={aspectRatio} src={source} />
			{active && <BonusCountText style={{}}>({bonusCount})</BonusCountText>}
		</ButtonWrapper>
	);
};
const Image = styled.img<{ aspectRatio: number; active: boolean }>(({ theme, aspectRatio, active }) => ({
	tintColor: active ? undefined : '#727272',
	height: 15,
	width: 15 * aspectRatio,
}));
const ButtonWrapper = styled.div<{
	active: boolean;
}>(({ theme, active }) => ({
	justifyContent: 'center',
	alignItems: 'center',
	backgroundColor: active ? theme.colors.black : '#EEEEEE',
	paddingLeft: 11,
	paddingRight: 11,
	paddingTop: 11,
	paddingBottom: 11,
	borderRadius: 30,
	marginLeft: 10,
	flexDirection: 'row',
	display: 'flex',
}));
const BonusCountText = styled.span({
	marginLeft: 5,
	fontWeight: '600',
	color: 'white',
});
